import React, { FC } from "react";

// Components
import { TableWrapper, TableBody, Column, HeaderCell, HeaderText, Cell } from "./PackingDetailsTable.styles";

// Constants
import colors from "css/colors";

// Interfaces
import { PackagingLevel } from "../../../../../interfaces/products";

// Libs
import WRO from "lib/fulfillment/WRO";

interface Props {
  packagingLevels: PackagingLevel[];
}

const PackingDetailsTable: FC<Props> = ({ packagingLevels }) => {
  const headerCells = [
    "Packing Level",
    "Base Products per Package",
    "SKU",
    "Description",
    "Length",
    "Width",
    "Height",
    "Weight",
  ];

  const getPackagingLevelCells = (packagingLevel: PackagingLevel) => {
    const {
      base_product_quantity,
      sku,
      description,
      length_value,
      length_unit,
      width_value,
      width_unit,
      height_value,
      height_unit,
      weight_value,
      weight_unit,
    } = packagingLevel;
    return (
      <>
        <Cell>{base_product_quantity}</Cell>
        <Cell>{sku}</Cell>
        <Cell>{description}</Cell>
        <Cell>
          {length_value} {length_unit}
        </Cell>
        <Cell>
          {width_value} {width_unit}
        </Cell>
        <Cell>
          {height_value} {height_unit}
        </Cell>
        <Cell>
          {weight_value} {weight_unit}
        </Cell>
      </>
    );
  };

  return (
    <TableWrapper>
      <TableBody>
        <Column>
          {headerCells.map((label) => (
            <HeaderCell key={label}>
              <HeaderText>{label}</HeaderText>
            </HeaderCell>
          ))}
        </Column>
        {packagingLevels.map(
          (packagingLevel) =>
            packagingLevel.level && (
              <Column key={packagingLevel.level}>
                <Cell color={colors.GREY}>{WRO.getPackagingLevelText(packagingLevel.level)}</Cell>
                {getPackagingLevelCells(packagingLevel)}
              </Column>
            )
        )}
      </TableBody>
    </TableWrapper>
  );
};

export default PackingDetailsTable;
